import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import 'animate.css';
import './LoadingScreen.css';

interface LoadingScreenProps {
  minDisplayTime?: number;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ minDisplayTime = 2000 }) => {
  const [progress, setProgress] = useState(0);
  const [showLoader, setShowLoader] = useState(true);
  const [loadingText, setLoadingText] = useState('جاري تحميل المنصة');

  useEffect(() => {
    const startTime = Date.now();
    
    // محاكاة تقدم التحميل بشكل أكثر سلاسة
    const interval = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress >= 100) return 100;
        
        // زيادة التقدم بشكل تدريجي
        const increment = Math.floor(Math.random() * 5) + 1;
        const newProgress = prevProgress + increment;
        
        return newProgress > 100 ? 100 : newProgress;
      });
    }, 150);

    // تغيير نص التحميل
    const textInterval = setInterval(() => {
      setLoadingText((prevText) => {
        if (prevText === 'جاري تحميل المنصة...') return 'جاري تحميل المنصة';
        if (prevText === 'جاري تحميل المنصة..') return 'جاري تحميل المنصة...';
        if (prevText === 'جاري تحميل المنصة.') return 'جاري تحميل المنصة..';
        return 'جاري تحميل المنصة.';
      });
    }, 500);

    // ضمان وقت عرض أدنى
    const timer = setTimeout(() => {
      const elapsedTime = Date.now() - startTime;
      
      if (elapsedTime >= minDisplayTime) {
        clearInterval(interval);
        clearInterval(textInterval);
        setProgress(100);
        
        // إضافة تأخير قصير قبل الإخفاء
        setTimeout(() => {
          setShowLoader(false);
        }, 500);
      }
    }, minDisplayTime);

    return () => {
      clearInterval(interval);
      clearInterval(textInterval);
      clearTimeout(timer);
    };
  }, [minDisplayTime]);

  if (!showLoader) {
    return null;
  }

  return (
    <div className="loading-screen">
      {/* خلفية متحركة */}
      <div className="animated-background">
        <div className="shape shape1"></div>
        <div className="shape shape2"></div>
        <div className="shape shape3"></div>
        <div className="shape shape4"></div>
      </div>
      
      <Container className="h-100 d-flex flex-column justify-content-center align-items-center position-relative">
        <div className="loading-content animate__animated animate__fadeIn">
          {/* شعار التطبيق */}
          <div className="logo-container mb-4">
            <img 
              src="https://a-samy.web.app/image/A.S_logo.png" 
              alt="منصة التعليم" 
              className="loading-logo"
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.onerror = null;
                target.src = 'https://via.placeholder.com/150?text=منصة+التعليم';
              }}
            />
          </div>
          
          {/* عنوان التحميل */}
          <h2 className="loading-title mb-4">{loadingText}<span className="loading-dots"></span></h2>
          
          {/* شريط التقدم */}
          <div className="progress-container mb-3 animate__animated animate__fadeInUp">
            <div className="progress-bar" style={{ width: `${progress}%` }}>
              <div className="progress-glow"></div>
            </div>
          </div>
          
          {/* نسبة التحميل */}
          <p className="loading-percentage animate__animated animate__fadeIn">{progress}%</p>
          
          {/* دائرة التحميل */}
          <div className="spinner-container mt-3 animate__animated animate__zoomIn">
            <div className="custom-spinner">
              <div className="spinner-ring"></div>
              <div className="spinner-ring"></div>
              <div className="spinner-ring"></div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default LoadingScreen;
